// Top navigation: menu toggle, breadcrumbs, navigation search, theme, notifications, profile menu.
import { html, render } from '../utilities/html.js';
import { icon } from '../utilities/icons.js';
import { avatar } from './visuals.js';
import { wirePopover } from './popover.js';
import { applyTheme, currentTheme, nextTheme } from '../services/theme.js';

const THEME_META = { dark: { icon: 'moon', label: 'Dark' }, light: { icon: 'sun', label: 'Light' }, system: { icon: 'monitor', label: 'System' } };

export function topbar({ profile, user }) {
  const name = profile?.full_name || user?.email || '';
  return html`
    <button class="icon-btn topbar__menu" type="button" data-action="toggle-nav" aria-label="Open navigation" aria-controls="sidebar">${icon('menu')}</button>
    <nav class="breadcrumbs hide-sm" aria-label="Breadcrumb" data-breadcrumbs></nav>
    <div class="topbar__spacer"></div>
    <button class="search-trigger" type="button" data-action="open-search" aria-label="Go to page (Ctrl+K)">${icon('search')}<span>Go to…</span><kbd>Ctrl K</kbd></button>
    <div class="topbar__actions">
      <button class="icon-btn" type="button" data-action="theme" aria-label="Theme"></button>
      <div class="anchor">
        <button class="icon-btn" type="button" data-action="notifications" aria-haspopup="true" aria-label="Notifications">
          ${icon('bell')}<span class="icon-btn__badge" data-unread hidden></span>
        </button>
        <div class="popover popover--wide" data-notifications-panel hidden></div>
      </div>
      <div class="anchor">
        <button class="icon-btn" type="button" data-action="profile" aria-haspopup="menu" aria-label="Account menu" style="width:auto;padding:0 4px">${avatar(profile?.full_name, user?.email, 'sm')}</button>
        <div class="popover" role="menu" data-profile-menu hidden>
          <div style="padding:var(--space-2) var(--space-3) var(--space-3)">
            <div class="text-strong truncate">${name}</div>
            <div class="text-xs text-subtle truncate">${user?.email ?? ''}</div>
          </div>
          <div class="menu-sep"></div>
          <a class="menu-item" role="menuitem" href="/profile">${icon('user')} My profile</a>
          <a class="menu-item" role="menuitem" href="/profile/security">${icon('lock')} Security</a>
          <div class="menu-sep"></div>
          <button class="menu-item" role="menuitem" type="button" data-action="sign-out" data-close-popover>${icon('logout')} Sign out</button>
        </div>
      </div>
    </div>`;
}

export function renderBreadcrumbs(target, crumbs = []) {
  if (!target) return;
  render(target, html`<ol>${crumbs.map((c, i) => {
    const last = i === crumbs.length - 1;
    const label = typeof c === 'string' ? c : c.label;
    if (last) return html`<li><span aria-current="page">${label}</span></li>`;
    return typeof c === 'object' && c.href ? html`<li><a href="${c.href}">${label}</a></li>` : html`<li>${label}</li>`;
  })}</ol>`);
}

export function wireThemeButton(btn, onChange) {
  const paint = () => {
    const t = currentTheme();
    const meta = THEME_META[t];
    btn.innerHTML = icon(meta.icon).value;
    btn.setAttribute('aria-label', `Theme: ${meta.label}. Switch to ${THEME_META[nextTheme(t)].label}`);
    btn.title = `Theme: ${meta.label}`;
  };
  paint();
  btn.addEventListener('click', () => {
    const t = applyTheme(nextTheme());
    paint();
    onChange?.(t);
  });
}

export function wireProfileMenu(root) {
  wirePopover(root.querySelector('[data-action="profile"]'), root.querySelector('[data-profile-menu]'));
}
